import { Row, TextWithTooltip } from "@hightouch/htui";

import { AttachmentTypeTile } from "src/components/llm/components/attachment-type-tile";
import { attachmentCategory } from "src/components/llm/utils/attachment-presentation";

/**
 * Long filenames truncate rather than push the chip across the transcript.
 * Not a Figma measurement: the mock's chips are sized by their sample names.
 */
const MAX_CHIP_WIDTH = 60;

/**
 * Compact presentation for a non-image attachment: a type tile and the filename
 * on one line. Images keep real thumbnails; this is what everything else in a
 * sent message looks like.
 *
 * `onPreview` is omitted for a file with no bytes or URL behind it, which
 * leaves a readable chip with no action that would do nothing.
 */
export const AttachmentChip = ({
  fileName,
  mimeType,
  onPreview,
}: {
  fileName: string;
  mimeType: string;
  onPreview?: () => void;
}) => {
  const category = attachmentCategory(mimeType, fileName);

  const contents = (
    <>
      <AttachmentTypeTile category={category} />
      <TextWithTooltip size="sm" color="text.primary">
        {fileName}
      </TextWithTooltip>
    </>
  );

  return (
    <Row
      align="center"
      gap={2}
      minHeight={8}
      pl={1.5}
      pr={2}
      py={1.5}
      maxWidth={MAX_CHIP_WIDTH}
      width="fit-content"
      minWidth={0}
      borderRadius="lg"
      bg="white"
      boxShadow="sm"
      flexShrink={1}
    >
      {onPreview ? (
        <Row
          as="button"
          type="button"
          align="center"
          gap={2}
          minWidth={0}
          width="100%"
          textAlign="left"
          borderRadius="md"
          cursor="pointer"
          _focusVisible={{ boxShadow: "outline" }}
          onClick={onPreview}
        >
          {contents}
        </Row>
      ) : (
        contents
      )}
    </Row>
  );
};
